import { type ReactNode } from 'react';
import { activeFirst } from '../data/active-status';
import { RoleSection } from './role-section';
import type { TeamMember } from '../types';

export function mergeAdmins(
  grouped: Record<string, TeamMember[]> | undefined
): Record<string, TeamMember[]> {
  if (!grouped) return {};
  const merged = { ...grouped };
  const admins = merged['admin'] ?? [];
  const collectors = merged['collector'] ?? [];
  merged['collector'] = [...admins, ...collectors].sort(
    (a, b) => (b.leads_count ?? 0) - (a.leads_count ?? 0)
  );
  delete merged['admin'];
  return merged;
}

export function filterSelf(
  pre: TeamMember[],
  userId: string | undefined,
  shouldFilter: boolean
): TeamMember[] {
  if (!shouldFilter || !userId) return pre;
  return pre.filter((m) => m.id !== userId);
}

function moveSelfFirst(
  members: TeamMember[],
  userId: string | undefined
): TeamMember[] {
  if (!userId) return members;
  const idx = members.findIndex((m) => m.id === userId);
  if (idx <= 0) return members;
  return [members[idx]!, ...members.slice(0, idx), ...members.slice(idx + 1)];
}

type Props = {
  merged: Record<string, TeamMember[]>;
  pre: TeamMember[];
  userId: string | undefined;
  onSelect?: (id: string) => void;
};

function CollectorSection(p: Props): ReactNode {
  const ordered = activeFirst(p.merged['collector'] ?? []);
  return (
    <RoleSection
      role="collector"
      members={moveSelfFirst(ordered, p.userId)}
      {...(p.onSelect && { onSelect: p.onSelect })}
    />
  );
}

// Solo Pre Collectors y Collectors: Approachers y Magos salen de esta pantalla
// y viven en el hub de /team (DEBOOK-1904). ComingSoonSection sigue disponible.
export function RoleSections(props: Props): ReactNode {
  return (
    <>
      {props.pre.length > 0 && (
        <RoleSection
          key="pre_collectors"
          role="pre_collectors"
          members={moveSelfFirst(props.pre, props.userId)}
          {...(props.onSelect && { onSelect: props.onSelect })}
          compact
        />
      )}
      <CollectorSection {...props} />
    </>
  );
}
